import { PageLocation } from './observeState';

export type EnvironmentState = {
  /** @deprecated */
  locale: string;
  language: string;
  /** @deprecated */
  pageLocation: PageLocation;
  embedded: boolean;
};
